import { addDictionaryExtraLine, TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useBuyTypeShippingDict = () => {
    const {t} = useTwinTranslation()
    const dictTypeShipping: TwinDictionary = addDictionaryExtraLine({
        0: { name: t('sendFromSupplier', 'Enviado por el proveedor') },
        1: { name: t('pickUpInSupplier', 'Recogida en el proveedor') }
    })
    return dictTypeShipping
}

export default useBuyTypeShippingDict